module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/193-norfolk-island-0293c6a5b3e36a85c177527dd541cf2e.svg";